<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <span class="cursor-pointer flex items-center i18n-locale">
      <img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />
      <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>
      <font-awesome-icon class="ml-2" :icon="['fas', 'chevron-down']"/>
    </span>
    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item
        v-for="lang in languages"
        :key="lang.code"
        @click="updateLocale(lang.code)"
      >
        <img class="h-4 w-5 mr-1" :src="lang.flag" :alt="lang.code" /> &nbsp;{{ lang.label }}
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  data() {
    return {
      languages: [
        { code: 'en', label: 'English', flag: require('@/assets/images/flags/en.png') },
        { code: 'it', label: 'Italian', flag: require('@/assets/images/flags/it.png') },
        { code: 'es', label: 'Spanish', flag: require('@/assets/images/flags/es.png') }
      ]
    }
  },
  computed: {
    i18n_locale_img () {
      const locale = this.$i18n.locale
      const lang = this.languages.find(l => l.code === locale)
      return lang ? lang.flag : this.languages[0].flag
    },
    getCurrentLocaleData () {
      const locale = this.$i18n.locale
      const lang = this.languages.find(l => l.code === locale)
      return lang ? { flag: lang.code, lang: lang.code.toUpperCase() } : { flag: 'en', lang: 'EN' }
    }
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const lang = params.get('lang') || localStorage.getItem('preferred_lang') || 'en';

    if (lang && this.languages.some(l => l.code === lang) && lang !== this.$i18n.locale) {
      this.updateLocale(lang);
    }
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
      this.$validator.locale = locale;
      this.$store.dispatch('updateUserInfo', { language: locale });
      localStorage.setItem('preferred_lang', locale);
    
      // Remove "lang" param from URL before reload
      const url = new URL(window.location.href);
      url.searchParams.delete('lang');
      window.history.replaceState({}, '', url.toString());
    
      window.location.reload();
    }
  }
}
</script>

<style lang="scss">
.i18n-dropdown {
  margin-left: -4px;
  margin-top: 15px;
}

.items-center.i18n-locale {
  span {
    color: #fff;
  }
}
</style>